import { uniqueId } from '@ember/helper'
import type { TOC } from '@ember/component/template-only'

interface SideNavGroupSignature {
  Args: {
    label?: string
    removeDividers?: boolean
  }
  Blocks: {
    default: []
  }
  Element: HTMLDivElement
}

export const SideNavGroup: TOC<SideNavGroupSignature> = <template>
  {{#let (uniqueId) as |uniqueId|}}
    <div ...attributes>
      {{#if @label}}<label
          id={{uniqueId}}
          class="text-dusty-black-400 px-4 py-2 text-sm font-semibold"
        >{{@label}}</label>{{/if}}
      <ul
        role="group"
        aria-labelledby={{if @label uniqueId}}
        class={{unless @removeDividers "border-dusty-black-50 [&>*:not(:last-child)]:border-b-2"}}
      >
        {{yield}}
      </ul>
    </div>
  {{/let}}
</template>

export default SideNavGroup
